import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '../../common/base';
import { FaqWrapper, FaqTitle } from './Styled';
import { Grid, Col, Accordion } from '../../common/interfaces';

import { withTranslation } from '../../common/libs/i18n';

const K_ACCORDION_LEFT_SIDE = ({ t }) => [
  {
    title: t('landing.faq.left_1_question', 'What is RupiahToken (IDRT)?'),
    desc: t(
      'landing.faq.left_1_answer',
      'Rupiah Token (IDRT) is the first Ethereum-based Token (ERC-20) that is fully collateralized 1:1 by Rupiah (IDR) fiat currency. Each IDRT is backed by equivalent amount of Fiat Rupiah, and can be redeemed for Fiat through our platform.'
    )
  },
  {
    title: t('landing.faq.left_2_question', "What's the price of Rupiah Token? When moon?"),
    desc: t(
      'landing.faq.left_2_answer',
      'Rupiah Token is a stablecoin, not an investment! The price will always stay at 1 IDR per token. You can always purchase 1 IDRT with 1 IDR, and you can always redeem 1 IDRT for 1 IDR.'
    )
  },
  {
    title: t(
      'landing.faq.left_3_question',
      'Where are the funds used as reserve being deposited at?'
    ),
    desc: t(
      'landing.faq.left_3_answer',
      'Funds used as IDRT reserve are safely held in an Indonesian-domiciled bank account. We will provide monthly audit proofs to prove the 1:1 backing authenticity.'
    )
  },
  {
    title: t('landing.faq.left_4_question', 'Where can I trade IDRT at?'),
    desc: t(
      'landing.faq.left_4_answer',
      'We are in the process of partnering with multiple exchanges. Stay tuned!'
    )
  }
];

const K_ACCORDION_RIGHT_SIDE = ({ t }) => [
  {
    title: t('landing.faq.right_1_question', 'Why is IDRT issued on the Ethereum blockchain?'),
    desc: t(
      'landing.faq.right_1_answer',
      'Ethereum is the most widely-used, trusted, and community-supported public blockchain that is equipped with Smart Contract capabilities. It is the blockchain of choice for Stablecoins and other Decentralized Finance (DeFi) movement. Releasing IDRT on top of Ethereum makes it inherently compatible with many exchanges, wallets, and other exciting DeFi projects (such as blockchain-based lending, etc) that are currently being developed globally.'
    )
  },
  {
    title: t(
      'landing.faq.right_2_question',
      'How can we trust the security of IDRT Smart Contract?'
    ),
    desc: t(
      'landing.faq.right_2_answer',
      "Our IDRT Token Smart Contract has been audited and verified by CertiK, the world's most trusted smart contract auditor. You can see our Audit Certificate at the footer of rupiahtoken.com website."
    )
  },
  {
    title: t(
      'landing.faq.right_3_question',
      'Do I need to register an account before purchasing / redeeming RupiahToken?'
    ),
    desc: t(
      'landing.faq.right_3_answer',
      'Yes, we are required by law to perform Know Your Customer / Anti-Money Laundering checks before we can allow you to purchase/redeem token from this website.'
    )
  }
];

const HomeFaq = ({ t }) => (
  <FaqWrapper>
    <Container>
      <FaqTitle>
        <Grid justify="center">
          <Col lg={6} md={12} text="center">
            <h2>{t('landing.faq.title', 'Frequently Asked Questions')}</h2>
          </Col>
        </Grid>
      </FaqTitle>
      <Grid>
        <Col lg={6} sm={12}>
          <Accordion data={K_ACCORDION_LEFT_SIDE({ t })} />
        </Col>
        <Col lg={6} sm={12}>
          <Accordion data={K_ACCORDION_RIGHT_SIDE({ t })} />
        </Col>
      </Grid>
      {/* <Margin top={32}>
        <Grid justify='center' text='center'>
          <Col lg={6} sm={12}>
            <Anchor href='/' type='button' outline>
              {content.faq.button_view_more}
            </Anchor>
          </Col>
        </Grid>
      </Margin> */}
    </Container>
  </FaqWrapper>
);

HomeFaq.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(HomeFaq);
